import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { RadarEchoTopsSvgComponent } from './radar-echo-tops-svg/radar-echo-tops-legend-svg';

export const RADAR_ECHO_TOPS_LEGEND: TwcLegendParams = {
  title: 'RADAR ECHO TOPS',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: RadarEchoTopsSvgComponent },
  legendComponent: TwcLegendComponent
};
